import { render, staticRenderFns } from "./TouchlessHome.vue?vue&type=template&id=3c2a139c&"
import script from "./TouchlessHome.vue?vue&type=script&lang=js&"
export * from "./TouchlessHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports